import React from 'react';

import {AppRoute} from '../../../models/AppRoute';
import useAppNavigation from '../../../navigation/useAppNavigation';
import {OffersItemWithMflId} from '../../../transport/types';
import TileLarge from '../../TileLarge';

function ExclusiveOffersTileLarge(props: OffersItemWithMflId) {
  const navigation = useAppNavigation();

  return (
    <TileLarge
      onPress={() => {
        if (props?.offerId) {
          navigation.navigate(AppRoute.EXCLUSIVE_OFFER_DETAIL, {
            offerId: props.offerId,
          });
        }
      }}
      image={props.heroImage?.[0]}
      title={props.tileHeadline}
      description={props.description}
    />
  );
}

export default ExclusiveOffersTileLarge;
